// Url's and Paths    
const dispatchNodeURL = "https://dispatch.pokt.network";
const dispatchPath = "/v1/dispatch";
const reportPath = "/v1/report";
const relayPath = "/v1/relay/";


module.exports = {
    dispatchNodeURL,
    dispatchPath,
    reportPath,
    relayPath
}